module.exports = __webpack_public_path__ + "img/auth3.afe6feea.png";